export default __webpack_public_path__ + "static/media/tekvisionlogo.190d6525.svg";